import React, { useRef, useReducer, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import ReactDOM from "react-dom";
import reducer from "./reducer";
import styles from "./LightBoxModal.module.scss";
const Contorls = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      onClose();
    },
    className: styles.modalClose
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.hideVisually
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: "Close",
    id: "rbrahO"
  })), /*#__PURE__*/React.createElement("svg", {
    className: styles.modalCloseIcon,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 L 30,30 M 30,10 L 10,30"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      onClose();
    },
    className: styles.modalClose
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.hideVisually
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: "Close",
    id: "rbrahO"
  })), /*#__PURE__*/React.createElement("svg", {
    className: styles.modalCloseIcon,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 L 30,30 M 30,10 L 10,30"
  }))));
};
const initialState = {
  imageSize: {},
  viewportSize: {},
  position: {},
  zoom: {},
  scale: 0,
  isLoaded: false,
  isZoomedIn: false
};
const LightBoxModal = ({
  imageUrl,
  close
}) => {
  const imageRef = useRef();
  const trackIsInMoveRef = useRef(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    isLoaded,
    isInMove,
    scale,
    isZoomedIn,
    imageSize,
    position
  } = state;
  useEffect(() => {
    imageRef.current = new Image();
    imageRef.current.src = imageUrl;
    imageRef.current.onload = () => {
      const {
        naturalWidth: width,
        naturalHeight: height
      } = imageRef.current;
      dispatch({
        type: "LOADED",
        imageSize: {
          width,
          height
        }
      });
    };
    return () => {
      imageRef.current.onload = undefined;
    };
  }, [imageUrl]);

  // viewport size
  useEffect(() => {
    const updateViewport = () => {
      dispatch({
        type: "VIEWPORT_SIZE_CHANGED",
        viewportSize: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      });
    };
    updateViewport();
    window.addEventListener("resize", updateViewport);
    return () => {
      window.removeEventListener("resize", updateViewport);
    };
  }, []);

  // block scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // move
  const handleDragStart = event => {
    event.preventDefault();
    document.addEventListener("mousemove", handleDragMove);
    document.addEventListener("mouseup", handleDragEnd);
    dispatch({
      type: "MOVE_STARTED",
      point: {
        x: event.pageX,
        y: event.pageY
      }
    });
  };
  const handleDragMove = event => {
    event.preventDefault();
    trackIsInMoveRef.current = true;
    dispatch({
      type: "MOVE",
      point: {
        x: event.pageX,
        y: event.pageY
      }
    });
  };
  const handleDragEnd = () => {
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    dispatch({
      type: "MOVE_ENDED"
    });
  };
  const handleClick = event => {
    event.stopPropagation();
    if (!trackIsInMoveRef.current) {
      dispatch({
        type: "TOGGLE_ZOOM",
        point: {
          x: event.clientX,
          y: event.clientY
        }
      });
    }
    trackIsInMoveRef.current = false;
  };
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("aside", {
    className: styles.modalCover,
    onClick: close
  }, /*#__PURE__*/React.createElement(Contorls, {
    onClose: close
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, isLoaded ? /*#__PURE__*/React.createElement("img", {
    onClick: handleClick,
    onMouseDown: handleDragStart,
    src: imageUrl,
    style: {
      transform: [`translate3d(${position.x}px, ${position.y}px, 0px)`, `scale(${scale})`].join(" "),
      transformOrigin: "left top",
      cursor: isInMove ? "grabbing" : isZoomedIn ? "zoom-out" : "zoom-in",
      transition: !isInMove ? "transform 0.3s" : undefined,
      width: imageSize.width,
      height: imageSize.height
    }
  }) : /*#__PURE__*/React.createElement("h1", {
    style: {
      color: "#fff"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: "Loading ...",
    id: "Sd5mzZ"
  })))), document.body);
};
export default LightBoxModal;
//# sourceMappingURL=LightBoxModal.js.map